export const variants = [
  {
    props: { variant: "Light Green" },
    style: ({ theme }) => ({
      fontFamily: theme.typography.fontFamily,
      fontSize: "16px",
      borderRadius: theme.shape.borderRadius * 2,
      color: theme.palette.text.navigation,
      "&:hover": {
        backgroundColor: theme.palette.background.button,
      },
    }),
  },
];
